import { z } from 'zod';

export type Position = [longitude: number, latitude: number];

export const positionSchema = z.tuple([z.number(), z.number()]);
